import type { NavItem } from '../app/navigation';
import { EmptyState } from '../components/EmptyState';
import { PageHeader } from '../components/PageHeader';
import { StatusBadge } from '../components/StatusBadge';

/**
 * Honest placeholder for modules whose backend does not exist yet. It shows the
 * module's purpose without fake data or controls that do nothing.
 */
export function ModulePage({ item }: { item: NavItem }) {
  return (
    <>
      <PageHeader
        title={item.label}
        description={item.summary}
        actions={<StatusBadge tone="neutral">Em construção</StatusBadge>}
      />
      <div className="p-4 sm:p-6">
        <div className="rounded-lg border border-dashed border-line-strong bg-surface">
          <EmptyState
            icon={item.icon}
            title={`${item.label} ainda não está disponível`}
            description="Este módulo será habilitado em uma próxima entrega da plataforma. A navegação e o layout já refletem sua posição final."
          />
        </div>
      </div>
    </>
  );
}
